import {createStyles, makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            backgroundColor: 'white',
            padding: 20,
            borderRadius: 5,
        },
        formContainer: {
            marginTop: 50,
        },
        tabsContainer: {
            // display: 'flex',
            justifyContent: 'flex-start',
        },
        radioButton: {
            fontSize: 12,
        },
        [theme.breakpoints.down('md')]: {
            formContainer: {
                backgroundColor: 'white',
                padding: '20px',
                marginTop: 0,
            },
            card: {
                marginTop: 32
            }
        },
    }),
);

export default useStyles;
